import { pisomImage } from "@/mocks/images";
import { pisom, site } from "@/mocks/site-data";
import Reveal from "@/components/feature/Reveal";

export default function Pisom() {
  return (
    <section id="pisom" className="scroll-mt-28 bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-8xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          <div className="order-2 lg:order-1">
            <Reveal>
              <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/40 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.16em] text-accent-300">
                {pisom.eyebrow}
              </span>
              <h2 className="mt-6 font-heading text-3xl font-medium leading-tight text-foreground-50 md:text-4xl lg:text-5xl">
                {pisom.title}
              </h2>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-400">
                {pisom.text}
              </p>
            </Reveal>

            <Reveal delay={100}>
              <h3 className="mt-10 text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
                {pisom.indicationsTitle}
              </h3>
              <ul className="mt-5 grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2">
                {pisom.indications.map((ind) => (
                  <li key={ind} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-accent-500/40">
                      <i className="ri-check-line text-xs text-accent-400" />
                    </span>
                    <span className="text-sm text-foreground-300">{ind}</span>
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={150}>
              <p className="mt-8 flex items-start gap-3 border-l-2 border-accent-500/50 pl-4 text-sm italic text-foreground-400">
                {pisom.discomfortNote}
              </p>

              <a
                href={site.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors duration-300 hover:bg-accent-400"
              >
                <i className="ri-whatsapp-line text-base" />
                {pisom.cta}
              </a>
            </Reveal>
          </div>

          <div className="order-1 lg:order-2">
            <Reveal>
              <div className="relative">
                <div className="absolute -right-3 -top-3 h-full w-full rounded-lg border border-accent-500/30 md:-right-5 md:-top-5" />
                <div className="relative">
                  <img
                    src={pisomImage}
                    alt="Equipamento laser PISOM no consultório da Dra. Sâmia Albuquerque"
                    title="Tecnologia laser PISOM"
                    className="relative w-full rounded-lg border border-accent-500/30 object-cover object-top aspect-[4/5]"
                  />
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}